"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _portalLayer = require("@common/components/share/portal-layer");
var _button = require("@design/ui/button");
var _input = require("@design/ui/input");
var _field = require("@design/ui/field");
var _dialog = require("@design/ui/dialog");
var _select = require("@design/ui/select");
var _categoryPaths = require("@common/utils/categoryPaths");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ROOT_LEVEL = "/";
function CreateCategoryModal(_ref) {
  var isOpen = _ref.isOpen,
    existingPaths = _ref.existingPaths,
    onCreateCategory = _ref.onCreateCategory,
    onClose = _ref.onClose;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    categoryName = _useState2[0],
    setCategoryName = _useState2[1];
  var _useState3 = (0, _react.useState)(ROOT_LEVEL),
    _useState4 = _slicedToArray(_useState3, 2),
    nestUnder = _useState4[0],
    setNestUnder = _useState4[1];
  var fieldId = (0, _react.useId)();
  var parentPaths = (0, _react.useMemo)(function () {
    return (0, _categoryPaths.getUniqueCategoryPathsWithPrefixes)(existingPaths);
  }, [existingPaths]);
  var handleCreate = function handleCreate(e) {
    e.preventDefault();
    if (!categoryName.trim()) return;
    var newPath = nestUnder === ROOT_LEVEL ? categoryName.trim() : "".concat(nestUnder, "/").concat(categoryName.trim());
    onCreateCategory(newPath);
    handleCancel();
  };
  var handleCancel = function handleCancel() {
    setCategoryName("");
    setNestUnder(ROOT_LEVEL);
    onClose();
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.Dialog, {
    open: isOpen,
    onOpenChange: handleCancel,
    "data-sentry-element": "Dialog",
    "data-sentry-component": "CreateCategoryModal",
    "data-sentry-source-file": "CreateCategoryModal.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogContent, {
      "aria-describedby": undefined,
      "data-sentry-element": "DialogContent",
      "data-sentry-source-file": "CreateCategoryModal.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogHeader, {
        "data-sentry-element": "DialogHeader",
        "data-sentry-source-file": "CreateCategoryModal.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogTitle, {
          "data-sentry-element": "DialogTitle",
          "data-sentry-source-file": "CreateCategoryModal.tsx",
          children: "Create category"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
        onSubmit: handleCreate,
        className: "contents",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex flex-col gap-4",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
            "data-sentry-element": "Field",
            "data-sentry-source-file": "CreateCategoryModal.tsx",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
              htmlFor: "".concat(fieldId, "-name"),
              "data-sentry-element": "FieldLabel",
              "data-sentry-source-file": "CreateCategoryModal.tsx",
              children: "Category name"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_input.Input, {
              id: "".concat(fieldId, "-name"),
              type: "text",
              value: categoryName,
              onChange: function onChange(e) {
                return setCategoryName(e.target.value);
              },
              placeholder: "Enter category name",
              "data-autofocus": true,
              "data-sentry-element": "Input",
              "data-sentry-source-file": "CreateCategoryModal.tsx"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
            "data-sentry-element": "Field",
            "data-sentry-source-file": "CreateCategoryModal.tsx",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
              id: "".concat(fieldId, "-parent-label"),
              htmlFor: "".concat(fieldId, "-parent"),
              "data-sentry-element": "FieldLabel",
              "data-sentry-source-file": "CreateCategoryModal.tsx",
              children: "Nest category under"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_select.Select, {
              value: nestUnder,
              onValueChange: setNestUnder,
              "data-sentry-element": "Select",
              "data-sentry-source-file": "CreateCategoryModal.tsx",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectTrigger, {
                id: "".concat(fieldId, "-parent"),
                "aria-labelledby": "".concat(fieldId, "-parent-label ").concat(fieldId, "-parent"),
                className: "w-full",
                "data-sentry-element": "SelectTrigger",
                "data-sentry-source-file": "CreateCategoryModal.tsx",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectValue, {
                  "data-sentry-element": "SelectValue",
                  "data-sentry-source-file": "CreateCategoryModal.tsx"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_select.SelectContent, _objectSpread(_objectSpread({}, _portalLayer.PORTAL_LAYER_PROPS), {}, {
                "data-sentry-element": "SelectContent",
                "data-sentry-source-file": "CreateCategoryModal.tsx",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectItem, {
                  value: ROOT_LEVEL,
                  "data-sentry-element": "SelectItem",
                  "data-sentry-source-file": "CreateCategoryModal.tsx",
                  children: "None (root level)"
                }), parentPaths.map(function (path) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectItem, {
                    value: path,
                    children: (0, _categoryPaths.formatCategoryPathForDisplay)(path)
                  }, path);
                })]
              }))]
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogFooter, {
          "data-sentry-element": "DialogFooter",
          "data-sentry-source-file": "CreateCategoryModal.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "button",
            variant: "outline",
            onClick: handleCancel,
            "data-sentry-element": "Button",
            "data-sentry-source-file": "CreateCategoryModal.tsx",
            children: "Cancel"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "submit",
            disabled: !categoryName.trim(),
            "data-sentry-element": "Button",
            "data-sentry-source-file": "CreateCategoryModal.tsx",
            children: "Create"
          })]
        })]
      })]
    })
  });
}
var _default = exports.default = CreateCategoryModal;